import { render, staticRenderFns } from "./achievementStatisticsTotal.vue?vue&type=template&id=55df999b&scoped=true"
import script from "./achievementStatisticsTotal.vue?vue&type=script&lang=js"
export * from "./achievementStatisticsTotal.vue?vue&type=script&lang=js"
import style0 from "./achievementStatisticsTotal.vue?vue&type=style&index=0&id=55df999b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df999b",
  null
  
)

export default component.exports